import { createSelector } from 'reselect';
import {
  selectStatus as selectSearchServiceStatus,
  selectResultsCount as selectSearchServiceResultsCount,
  LOADING as SEARCH_SERVICE_LOADING,
} from 'services/search';
import { NAMESPACE } from './constants';

const selectIsSearchLoading = createSelector(
  selectSearchServiceStatus,
  (results) => results === SEARCH_SERVICE_LOADING
);

const selectFilteredResultsCount = (state) => (
  state[NAMESPACE].filteredResultsCount || selectSearchServiceResultsCount(state)
);

export { selectIsSearchLoading, selectFilteredResultsCount };



// WEBPACK FOOTER //
// ./src/containers/Search/selectors.js